import React from "react";
import { FormControl } from "react-bootstrap";
import { QuestionInterface, AnswerInterface, ApiHelper, PlaylistInterface, MessageInterface } from "../../helpers";

interface Props {
  question: QuestionInterface,
  answer: AnswerInterface,
  updateValue: (questionId: number, newValue: string) => void,
  includeMessages: boolean
}

export const PlaylistAnswer: React.FC<Props> = props => {
  const [playlists, setPlaylists] = React.useState<PlaylistInterface[]>(null);
  const [messages, setMessages] = React.useState<MessageInterface[]>(null);

  const handleChange = (e: any) => {
    let val = e.currentTarget.value;
    props.updateValue(props.question.id, val);
  }

  const getOptions = () => {
    const playlistOptions: React.ReactElement[] = [];
    const messageOptions: React.ReactElement[] = [];
    const result: React.ReactElement[] = []

    let allVals: string[] = [];


    playlists?.forEach(p => {
      if (!props.question?.choices || props.question?.choices === p.shape) {
        playlistOptions.push(<option value={p.id}>{p.name}</option>);
        allVals.push(p.id.toString());
      }
    });

    messages?.forEach(m => {
      if (!props.question?.choices || props.question?.choices === m.shape) {
        messageOptions.push(<option value={"m" + m.id}>{m.name}</option>);
        allVals.push("m" + m.id.toString());
      }
    });

    if (playlistOptions.length > 0) result.push(<optgroup label="Playlists">{playlistOptions}</optgroup>);
    if (messageOptions.length > 0) result.push(<optgroup label="Messages">{messageOptions}</optgroup>);

    if (props.question && props.answer && !props.answer.value) {
      if (playlists?.length > 0) props.updateValue(props.question.id, playlists[0].id.toString())
      else if (messages?.length > 0) props.updateValue(props.question.id, "m" + messages[0].id.toString())
    }
    if (props.question && allVals.length > 0) {
      if (!props.answer) props.updateValue(props.question.id, allVals[0]);
      else if (allVals.indexOf(props.answer?.value || "") === -1) props.updateValue(props.question.id, allVals[0]);
    }
    console.log(props.answer);

    return result;
  }

  const fetchData = async () => {
    await ApiHelper.get<PlaylistInterface[]>("/playlists")
      .then(data => setPlaylists(data || []))
      .catch(err => console.error("Failed to load playlists:", err));
    if (props.includeMessages) await ApiHelper.get<MessageInterface[]>("/messages")
      .then(data => setMessages(data || []))
      .catch(err => console.error("Failed to load messages:", err));
    else setMessages([]);

    let defaultValue = "";

    playlists?.forEach(p => {
      if (!props.question?.choices || props.question?.choices === p.shape) {
        if (!defaultValue) defaultValue = p.id.toString();
      }
    });

    messages?.forEach(m => {
      if (!props.question?.choices || props.question?.choices === m.shape) {
        if (!defaultValue) defaultValue = "m" + m.id;
      }
    });

    if (props.question && props.answer && !props.answer.value) props.updateValue(props.question.id, defaultValue);
  }

  React.useEffect(() => { fetchData() }, []); // eslint-disable-line

  return (<FormControl as="select" value={props.answer?.value} onChange={handleChange}>{getOptions()}</FormControl>);

}